import React from 'react'
import './SelectedOption.css'

const SelectedOption = ({ label, value }) => {
  return (
    <React.Fragment>
      <div className="selected-option flex">
        <div className="apl-5 apr-5">{label}</div>
        <div className="apl-5 apr-5">{value}</div>
      </div>
    </React.Fragment>
  )
}

export default SelectedOption
